import React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { CardBody } from '@change/ds-core-ui/Card';
import { Text } from '@change/ds-core-ui/Text';
import { cn } from '@change/ds-utils';

import { isFieldFocused, shouldHighlightText } from '../../helpers/validation';
import type { FocusedField } from '../../types';

type EndorsementCardBodyContentProps = {
	displayDescription: string;
	isDescriptionPlaceholder: boolean;
	focusedField: FocusedField;
	onReadMore?: () => void;
	readMoreLabel?: string;
};

export const EndorsementCardBodyContent: React.FC<EndorsementCardBodyContentProps> = ({
	displayDescription,
	isDescriptionPlaceholder,
	focusedField,
	onReadMore,
	readMoreLabel,
}) => {
	const isStatementFocused = isFieldFocused('statement', focusedField);
	const shouldHighlightDescription = shouldHighlightText(isStatementFocused, !isDescriptionPlaceholder);

	return (
		<CardBody className="min-w-0 overflow-hidden p-0!">
			<Text
				as="p"
				className={cn(
					'leading-7 break-words whitespace-pre-line',
					isDescriptionPlaceholder && 'text-typography-strong!',
					shouldHighlightDescription && 'text-typography-interactive!',
				)}
				expressive
			>
				{displayDescription}
			</Text>
			{onReadMore && readMoreLabel && (
				<Button
					onClick={onReadMore}
					className="text-typography-strong mt-4 -ml-4"
					data-testid="endorsement-toggle-button"
					variant="tertiary"
					size="x-small"
				>
					{readMoreLabel}
				</Button>
			)}
		</CardBody>
	);
};
